import React from "react";
import "./SideMenu.scss";
import { Link, useLocation } from "react-router-dom";

const SideMenu = () => {
  const location = useLocation();
  return (
    <div className="SideListCont">
      <ul className="list">
        <li>
          <Link
            className={location.pathname.includes("about") ? "activeLink" : ""}
            to="/about"
          >
            О компании
          </Link>
        </li>
        <li>
          <Link
            className={
              location.pathname.includes("management") ? "activeLink" : ""
            }
            to="/management"
          >
            Руководство
          </Link>
        </li>
        <li>
          <Link
            className={
              location.pathname.includes("documents") ? "activeLink" : ""
            }
            to="/documents"
          >
            Документы
          </Link>
        </li>
        <li>
          <Link
            className={location.pathname.includes("news") ? "activeLink" : ""}
            to="/news"
          >
            Новости
          </Link>
        </li>
        <li>
          <Link
            className={
              location.pathname.includes("purchase") ? "activeLink" : ""
            }
            to="/purchase"
          >
            Закупки
          </Link>
        </li>
        <li>
          <Link
            className={
              location.pathname.includes("security") ? "activeLink" : ""
            }
            to="/security"
          >
            Охрана труда
          </Link>
        </li>
        <li>
          <Link
            className={
              location.pathname.includes("actives") ? "activeLink" : ""
            }
            to="/actives"
          >
            Непрофильные активы
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SideMenu;
